import '../../../css/draggable.css';
import { FaChevronUp, FaChevronDown } from "react-icons/fa";

function IngredientRow({ ingredient, index, moveUp, moveDown, updateEcological, ingredientsLength}) {
    return (
      <tr>
        <td>
            {ingredient.ingredient_name}
        </td>
        <td>
        {index >= 0 && (
            <button 
                onClick={() => moveUp(ingredient.id)}
                disabled={index === 0}
                className='order-button'
            >
                <FaChevronUp />
            </button>
            )}
            {index < index + 1 && (
                <button 
                onClick={() => moveDown(ingredient.id)}
                disabled={index === ingredientsLength - 1}
                className="order-button"
                >
                    <FaChevronDown />
                </button>
            )}
        </td>
        <td>
          <input
            type="checkbox"
            checked={ingredient.ecological_agriculture}
            onChange={(e) => updateEcological(ingredient.id, e.target.checked)}
            className="checkbox-1"
          />
        </td>
        <td>{ingredient.ingredient.ingredient_type?.name}</td>
      </tr>
    );
  }

  export default IngredientRow;